// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_twOwg {
  display: flex;
  flex-direction: row;
  align-items: top;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 5px solid var(--background);
}
.header_twOwg .playScenarioButton_hSxJ5 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.header_twOwg .playScenarioButton_hSxJ5:focus,
.header_twOwg .playScenarioButton_hSxJ5:active,
.header_twOwg .playScenarioButton_hSxJ5:focus:active {
  box-shadow: none;
  outline: none;
}
.fullWidth_qELSx {
  width: 100%;
}
.footer_nrD5U {
  background: var(--grey);
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.footer_nrD5U .stopButton_dLaCZ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 12px;
}
.footer_nrD5U .stopButton_dLaCZ:focus,
.footer_nrD5U .stopButton_dLaCZ:active,
.footer_nrD5U .stopButton_dLaCZ:focus:active {
  box-shadow: none;
  outline: none;
}
.valueEditorCard_UfHNT {
  min-width: 250px;
}
.valueEditorCard_UfHNT .valueEditorCard_UfHNT {
  border: none;
  margin: 5px 0;
  padding: 0;
}
.popover_NboOP {
  min-width: 300px;
}
.popover_NboOP > h3 {
  color: var(--pink);
}
.realMsg_ZVR0V {
  color: var(--light-grey);
  font-size: var(--font-size-small);
  text-transform: capitalize;
}
.attributeEditor_Om8JF {
  text-align: center;
}
.liveMsg_g5qt5 {
  text-align: center;
  padding: 5px;
}
.liveMsg_g5qt5 strong {
  text-transform: uppercase;
  color: var(--pink);
}
.dialog_bt0yr {
  background: white;
  min-height: 30vh;
  min-width: 50vw;
  display: flex;
}
.question_xGeDV {
  background: white;
}
.dialog_bt0yr > div {
  width: 100%;
  min-height: 30vh;
  justify-content: space-between;
}
.dialog_bt0yr .collectionKey_LDeHT {
  border-radius: 0;
  border: 1px solid #e5e5e5;
  height: 32px;
  width: 171px;
}
.dialog_bt0yr .collectionKey_LDeHT:focus {
  border: 1px solid #5737BE;
}
.rootEditor_GAvie.collectionEditor_Ew9hZ {
  width: 100%;
  margin: 8px;
  border-radius: 5px;
  border: 1px solid rgba(173, 173, 173, 0.3);
}
.rootEditor_GAvie.collectionItemEditor_BLRB3 {
  border-radius: 5px;
  border: 1px solid rgba(173, 173, 173, 0.3);
}
.collectionEditor_Ew9hZ > * {
  margin-bottom: 8px;
}
.collectionEditor_Ew9hZ > *:last-child {
  margin-bottom: 0px;
}
.collectionEditor_Ew9hZ .editorList_Lgrkw > * {
  margin-left: 0;
  margin-right: 0;
}
.collectionEditor_Ew9hZ .editorList_Lgrkw {
  flex-wrap: wrap;
  padding: 8px;
}
.dialog_bt0yr .title_DSAWw {
  font-weight: bold;
  font-size: 14px;
}
.delete_iOHms,
.row_Y5XFy .force_cZSa9.right_WJhBC {
  margin-left: auto;
}
.row_Y5XFy {
  width: 100%;
  padding: 8px;
}
.collectionTitle_bWvLn {
  font-weight: bold;
  font-size: 14px;
}

.grpAttrView_PQzGV {
  display: grid;
  grid-template-columns: auto 1fr auto;
  justify-content: stretch;
  align-items: center;
  gap: 0 8px;
  /* margin-left : 32px; */
}

.attrViewHeader_zbYLw {
  display : flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.attrViewPath_DaEHD {
  justify-self: end;
  color: var(--light-grey);
  font-size: 12px;
}

.attrView_w80MD {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 0 10px;
  justify-content: stretch;
  align-items: center;
}

.attrViewLabel_J0k0Y {
  min-width: 120px;
  background-color: white;
  min-height: 24px;
  color : var( --dark-grey, #6f6f6f );
  color : #67798e;
  /* font-size : var( --font-size-base ); */
  font: 600 13px / 20px var(--vf-Inter);
  line-height: 24px;

  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  display: flex;
  flex-wrap: nowrap;
}

.grpAttrDiv_nWiOY {
  width : 100%;
  height: 1px;
  background-color: #dddddd;
  grid-column-start: 1;
  grid-column-end: 4;
  margin : 2px 0;
}

.grpAttrNested_hSyzp, .grpAttrSpanView_a5t31 {
  grid-column-start: 1;
  grid-column-end: 4;
}

.grpAttrNested_hSyzp {
  /* margin-left: 16px; */
}

.grpAttrSpanView_a5t31 .grpAttrNested_hSyzp {
  margin-left: 40px;
}

.attrLabel_hEL7J {
  padding-right:8px;
}

.attrArrow_YFkgs { 
  padding-right:8px;
  color : var( --pink );
}

.flex_VNO9K, .flexRight_wCI2u, .flexSpaceBetween__5IDK, .jsonViewButtons_CyxyW {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}


.flexRight_wCI2u {
  justify-content: flex-end;
}

.grpAttrSpanView_a5t31 > .flex_VNO9K, .flexSpaceBetween__5IDK {
  justify-content: space-between;
}

.jsonView_rn47z {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: column;
}

.jsonViewButtons_CyxyW {
  padding: 8px;
  gap : 8px;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/screens/simcontrol/style.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;;;EAGE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;;;EAGE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,yCAAyC;EACzC,qCAAqC;EACrC,iBAAiB;;EAEjB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B","sourcesContent":["@import \"../../style/theme.css\";\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: top;\n  justify-content: space-between;\n  padding: 10px;\n  border-bottom: 5px solid var(--background);\n}\n.header .playScenarioButton {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n.header .playScenarioButton:focus,\n.header .playScenarioButton:active,\n.header .playScenarioButton:focus:active {\n  box-shadow: none;\n  outline: none;\n}\n.fullWidth {\n  width: 100%;\n}\n.footer {\n  background: var(--grey);\n  color: white;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.footer .stopButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  font-size: 12px;\n}\n.footer .stopButton:focus,\n.footer .stopButton:active,\n.footer .stopButton:focus:active {\n  box-shadow: none;\n  outline: none;\n}\n.valueEditorCard {\n  min-width: 250px;\n}\n.valueEditorCard .valueEditorCard {\n  border: none;\n  margin: 5px 0;\n  padding: 0;\n}\n.popover {\n  min-width: 300px;\n}\n.popover > h3 {\n  color: var(--pink);\n}\n.realMsg {\n  color: var(--light-grey);\n  font-size: var(--font-size-small);\n  text-transform: capitalize;\n}\n.attributeEditor {\n  text-align: center;\n}\n.liveMsg {\n  text-align: center;\n  padding: 5px;\n}\n.liveMsg strong {\n  text-transform: uppercase;\n  color: var(--pink);\n}\n.dialog {\n  background: white;\n  min-height: 30vh;\n  min-width: 50vw;\n  display: flex;\n}\n.question {\n  background: white;\n}\n.dialog > div {\n  width: 100%;\n  min-height: 30vh;\n  justify-content: space-between;\n}\n.dialog .collectionKey {\n  border-radius: 0;\n  border: 1px solid #e5e5e5;\n  height: 32px;\n  width: 171px;\n}\n.dialog .collectionKey:focus {\n  border: 1px solid #5737BE;\n}\n.rootEditor.collectionEditor {\n  width: 100%;\n  margin: 8px;\n  border-radius: 5px;\n  border: 1px solid rgba(173, 173, 173, 0.3);\n}\n.rootEditor.collectionItemEditor {\n  border-radius: 5px;\n  border: 1px solid rgba(173, 173, 173, 0.3);\n}\n.collectionEditor > * {\n  margin-bottom: 8px;\n}\n.collectionEditor > *:last-child {\n  margin-bottom: 0px;\n}\n.collectionEditor .editorList > * {\n  margin-left: 0;\n  margin-right: 0;\n}\n.collectionEditor .editorList {\n  flex-wrap: wrap;\n  padding: 8px;\n}\n.dialog .title {\n  font-weight: bold;\n  font-size: 14px;\n}\n.delete,\n.row .force.right {\n  margin-left: auto;\n}\n.row {\n  width: 100%;\n  padding: 8px;\n}\n.collectionTitle {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.grpAttrView {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  justify-content: stretch;\n  align-items: center;\n  gap: 0 8px;\n  /* margin-left : 32px; */\n}\n\n.attrViewHeader {\n  display : flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.attrViewPath {\n  justify-self: end;\n  color: var(--light-grey);\n  font-size: 12px;\n}\n\n.attrView {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  padding: 0 10px;\n  justify-content: stretch;\n  align-items: center;\n}\n\n.attrViewLabel {\n  min-width: 120px;\n  background-color: white;\n  min-height: 24px;\n  color : var( --dark-grey, #6f6f6f );\n  color : #67798e;\n  /* font-size : var( --font-size-base ); */\n  font: 600 13px / 20px var(--vf-Inter);\n  line-height: 24px;\n\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.grpAttrDiv {\n  width : 100%;\n  height: 1px;\n  background-color: #dddddd;\n  grid-column-start: 1;\n  grid-column-end: 4;\n  margin : 2px 0;\n}\n\n.grpAttrNested, .grpAttrSpanView {\n  grid-column-start: 1;\n  grid-column-end: 4;\n}\n\n.grpAttrNested {\n  /* margin-left: 16px; */\n}\n\n.grpAttrSpanView .grpAttrNested {\n  margin-left: 40px;\n}\n\n.attrLabel {\n  padding-right:8px;\n}\n\n.attrArrow { \n  padding-right:8px;\n  color : var( --pink );\n}\n\n.flex, .flexRight, .flexSpaceBetween, .jsonViewButtons {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n\n\n.flexRight {\n  justify-content: flex-end;\n}\n\n.grpAttrSpanView > .flex, .flexSpaceBetween {\n  justify-content: space-between;\n}\n\n.jsonView {\n  display: flex;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  flex-direction: column;\n}\n\n.jsonViewButtons {\n  padding: 8px;\n  gap : 8px;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_twOwg`,
	"playScenarioButton": `playScenarioButton_hSxJ5`,
	"fullWidth": `fullWidth_qELSx`,
	"footer": `footer_nrD5U`,
	"stopButton": `stopButton_dLaCZ`,
	"valueEditorCard": `valueEditorCard_UfHNT`,
	"popover": `popover_NboOP`,
	"realMsg": `realMsg_ZVR0V`,
	"attributeEditor": `attributeEditor_Om8JF`,
	"liveMsg": `liveMsg_g5qt5`,
	"dialog": `dialog_bt0yr`,
	"question": `question_xGeDV`,
	"collectionKey": `collectionKey_LDeHT`,
	"rootEditor": `rootEditor_GAvie`,
	"collectionEditor": `collectionEditor_Ew9hZ`,
	"collectionItemEditor": `collectionItemEditor_BLRB3`,
	"editorList": `editorList_Lgrkw`,
	"title": `title_DSAWw`,
	"delete": `delete_iOHms`,
	"row": `row_Y5XFy`,
	"force": `force_cZSa9`,
	"right": `right_WJhBC`,
	"collectionTitle": `collectionTitle_bWvLn`,
	"grpAttrView": `grpAttrView_PQzGV`,
	"attrViewHeader": `attrViewHeader_zbYLw`,
	"attrViewPath": `attrViewPath_DaEHD`,
	"attrView": `attrView_w80MD`,
	"attrViewLabel": `attrViewLabel_J0k0Y`,
	"grpAttrDiv": `grpAttrDiv_nWiOY`,
	"grpAttrNested": `grpAttrNested_hSyzp`,
	"grpAttrSpanView": `grpAttrSpanView_a5t31`,
	"attrLabel": `attrLabel_hEL7J`,
	"attrArrow": `attrArrow_YFkgs`,
	"flex": `flex_VNO9K`,
	"flexRight": `flexRight_wCI2u`,
	"flexSpaceBetween": `flexSpaceBetween__5IDK`,
	"jsonViewButtons": `jsonViewButtons_CyxyW`,
	"jsonView": `jsonView_rn47z`
};
export default ___CSS_LOADER_EXPORT___;
